export const BANNER_REFRESH_TIMEOUT = 600000; // 10 minutes
export const ANIMATION_DURATION = 500;
export const FLOATING_NOTIFICATION_TIMEOUT = 12000;
/**
 * Least amount of time a tease will show. The pop-up may opt
 * to show longer depending on the duration of the chosen sound
 */
export const TEASE_ALERT_MINIMUM_TIMEOUT = 5000;
export const UNDO_ARCHIVING_TIMEOUT = 5000;
export const SHOW_OPT_OUT_SUCCESS_TIMEOUT = 5000;
export const CONFIRMATION_ALERT_TIMEOUT = 2000;
export let DELIVERY_METHOD_NAMES;
(function (DELIVERY_METHOD_NAMES) {
  DELIVERY_METHOD_NAMES["FLOATING"] = "FLOATING";
  DELIVERY_METHOD_NAMES["TEASE"] = "TEASE";
  DELIVERY_METHOD_NAMES["BANNER"] = "BANNER";
  DELIVERY_METHOD_NAMES["BROWSER"] = "BROWSER";
  DELIVERY_METHOD_NAMES["SIDEBAR"] = "NOTIFICATION_SIDEBAR";
})(DELIVERY_METHOD_NAMES || (DELIVERY_METHOD_NAMES = {}));
export let NOTIFICATION_TYPES;
(function (NOTIFICATION_TYPES) {
  NOTIFICATION_TYPES["ACCOUNT"] = "ACCOUNT";
  NOTIFICATION_TYPES["ASSIGN"] = "ASSIGN";
  NOTIFICATION_TYPES["BILLING"] = "BILLING";
  NOTIFICATION_TYPES["COMMENT"] = "COMMENT";
  NOTIFICATION_TYPES["CONNECT_COM"] = "CONNECT_COM";
  NOTIFICATION_TYPES["COPY"] = "COPY";
  NOTIFICATION_TYPES["CUSTOM_AUTOMATION_NOTIFICATION"] = "CUSTOM_AUTOMATION_NOTIFICATION";
  NOTIFICATION_TYPES["ERROR"] = "ERROR";
  NOTIFICATION_TYPES["EXAMPLE"] = "EXAMPLE";
  NOTIFICATION_TYPES["EXPORT"] = "EXPORT";
  NOTIFICATION_TYPES["FOLLOW"] = "FOLLOW";
  NOTIFICATION_TYPES["IMPORT"] = "IMPORT";
  NOTIFICATION_TYPES["LEAD_REVISIT"] = "LEAD_REVISIT";
  NOTIFICATION_TYPES["MENTION"] = "MENTION";
  NOTIFICATION_TYPES["OVERDUE"] = "OVERDUE";
  NOTIFICATION_TYPES["PARTNER_COLLABORATION"] = "PARTNER_COLLABORATION";
  NOTIFICATION_TYPES["RECOMMENDATION"] = "RECOMMENDATION";
  NOTIFICATION_TYPES["REMINDER"] = "REMINDER";
  NOTIFICATION_TYPES["REPLY"] = "REPLY";
  NOTIFICATION_TYPES["REPORTS"] = "REPORTS";
  NOTIFICATION_TYPES["SHARE"] = "SHARE";
  NOTIFICATION_TYPES["STATUS"] = "STATUS";
  NOTIFICATION_TYPES["SUBMISSION"] = "SUBMISSION";
  NOTIFICATION_TYPES["VIEW"] = "VIEW";
  NOTIFICATION_TYPES["WELCOME"] = "WELCOME";
  NOTIFICATION_TYPES["GENERAL"] = "GENERAL";
  NOTIFICATION_TYPES["FILE"] = "FILE";
  NOTIFICATION_TYPES["PAYMENT"] = "PAYMENT";
})(NOTIFICATION_TYPES || (NOTIFICATION_TYPES = {}));
export const ARCHIVED = 'ARCHIVED';
export const SELECT_ALL_FILTERS = 'SELECT_ALL_FILTERS';
export const EXAMPLE = NOTIFICATION_TYPES.EXAMPLE;
export const ANY = 'any';
export let NOTIFICATION_ACTIONS;
(function (NOTIFICATION_ACTIONS) {
  NOTIFICATION_ACTIONS["DELIVERED"] = "DELIVERED";
  NOTIFICATION_ACTIONS["MARKED_AS_READ"] = "MARKED_AS_READ";
  NOTIFICATION_ACTIONS["CTA_CLICKED"] = "CTA_CLICKED";
  NOTIFICATION_ACTIONS["NOTIFICATION_CLICKED_ACTION"] = "notification-clicked";
  NOTIFICATION_ACTIONS["NOTIFICATION_DISMISSED_ACTION"] = "notification-dismissed";
  NOTIFICATION_ACTIONS["TURNED_OFF_NOTIFICATION_TYPE"] = "turned-off-notification-type";
})(NOTIFICATION_ACTIONS || (NOTIFICATION_ACTIONS = {}));
export let SIDEBAR_ACTIONS;
(function (SIDEBAR_ACTIONS) {
  SIDEBAR_ACTIONS["ARCHIVED_ALL_NOTIFICATIONS"] = "archived-all-notifications";
  SIDEBAR_ACTIONS["ARCHIVED_MANY_NOTIFICATIONS"] = "archived-many-notifications";
  SIDEBAR_ACTIONS["ARCHIVED_ONE_NOTIFICATION"] = "archived-one-notification";
  SIDEBAR_ACTIONS["CLICKED_CALL"] = "clicked-call-associated-profile";
  SIDEBAR_ACTIONS["CLICKED_EMAIL"] = "clicked-email-associated-profile";
  SIDEBAR_ACTIONS["CLICKED_FILTER_POPOVER_BUTTON"] = "clicked-filter-popover-button";
  SIDEBAR_ACTIONS["CLICKED_PROFILE"] = "clicked-associated-profile";
  SIDEBAR_ACTIONS["CLICKED_SEE_MORE_PROFILES"] = "clicked-more-associated-profiles";
  SIDEBAR_ACTIONS["CLICKED_SEE_MORE_TEXT"] = "clicked-more-text";
  SIDEBAR_ACTIONS["FETCHED_MORE_NOTIFICATIONS"] = "fetched-more-notifications";
  SIDEBAR_ACTIONS["LOADED_WIDGET"] = "loaded-widget";
  SIDEBAR_ACTIONS["MARKED_NOTIFICATION_AS_READ"] = "marked-notification-as-read";
  SIDEBAR_ACTIONS["MARKED_ALL_NOTIFICATIONS_AS_READ"] = "marked-all-notifications-as-read";
  SIDEBAR_ACTIONS["NOTIFICATIONS_ARCHIVED_EMPTY_STATE_SHOWN"] = "notifications-archived-empty-state-shown";
  SIDEBAR_ACTIONS["OPENED_ACTIONS_POPOVER"] = "opened-actions-popover";
  SIDEBAR_ACTIONS["OPENED_FILTER_DROPDOWN"] = "opened-filter-dropdown";
  SIDEBAR_ACTIONS["OPENED_NOTIFICATION_MENU"] = "opened-notification-menu";
  SIDEBAR_ACTIONS["OPENED_SIDEBAR"] = "opened-sidebar";
  SIDEBAR_ACTIONS["CLOSED_SIDEBAR"] = "closed-sidebar";
  SIDEBAR_ACTIONS["PREFERENCES_LINK_CLICKED"] = "preferences-link-clicked";
  SIDEBAR_ACTIONS["TURNED_OFF_NOTIFICATION_TYPE"] = "turned-off-notification-type";
  SIDEBAR_ACTIONS["UNARCHIVED_ALL_NOTIFICATIONS"] = "unarchived-all-notifications";
  SIDEBAR_ACTIONS["UNARCHIVED_MANY_NOTIFICATIONS"] = "unarchived-many-notifications";
  SIDEBAR_ACTIONS["UNARCHIVED_ONE_NOTIFICATION"] = "unarchived-one-notification";
  SIDEBAR_ACTIONS["UNDO_ARCHIVING"] = "undo-archiving";
  SIDEBAR_ACTIONS["UNDO_UNARCHIVING"] = "undo-unarchiving";
  SIDEBAR_ACTIONS["INVITE_USER_CTA_CLICKED"] = "invite-user-cta-clicked";
  SIDEBAR_ACTIONS["INVITE_USER_MODAL_OPENED"] = "invite-user-modal-opened";
  SIDEBAR_ACTIONS["INVITE_USER_EMPTY_STATE_SEEN"] = "invite-user-empty-state-seen";
})(SIDEBAR_ACTIONS || (SIDEBAR_ACTIONS = {}));
export const SIDEBAR_V2_ACTIONS = {
  DELETED_ALL_NOTIFICATIONS: 'deleted-all-notifications',
  DELETED_MANY_NOTIFICATIONS: 'deleted-many-notifications',
  DELETED_ONE_NOTIFICATION: 'deleted-one-notification',
  FILTERED_NOTIFICATIONS_BY_TYPE: 'filtered-notifications-by-type',
  NOTIFICATION_CLICKED: 'notification-clicked',
  FETCHED_MORE_NOTIFICATIONS: 'fetched-more-notifications',
  LOADED_WIDGET: 'loaded-widget',
  MARKED_NOTIFICATION_AS_READ: 'marked-notification-as-read',
  MARKED_MANY_NOTIFICATIONS_AS_READ: 'marked-many-notifications-as-read',
  MARKED_ALL_NOTIFICATIONS_AS_READ: 'marked-all-notifications-as-read',
  MARKED_NOTIFICATION_AS_UNREAD: 'marked-notification-as-unread',
  MARKED_MANY_NOTIFICATIONS_AS_UNREAD: 'marked-many-notifications-as-unread',
  OPENED_SIDEBAR: 'opened-sidebar',
  PREFERENCES_LINK_CLICKED: 'preferences-link-clicked',
  TURNED_OFF_NOTIFICATION_TYPE: 'turned-off-notification-type',
  RESTORED_ALL_NOTIFICATIONS: 'restored-all-notifications',
  RESTORED_MANY_NOTIFICATIONS: 'restored-many-notifications',
  RESTORED_ONE_NOTIFICATION: 'restored-one-notification',
  INVITE_USER_CTA_CLICKED: 'invite-user-cta-clicked',
  INVITE_USER_MODAL_OPENED: 'invite-user-modal-opened',
  INVITE_USER_EMPTY_STATE_SEEN: 'invite-user-empty-state-seen',
  SWITCH_TO_UNREAD_TAB: 'switch-to-unread-tab',
  SWITCH_TO_ALL_TAB: 'switch-to-all-tab',
  SWITCH_TO_TRASH_TAB: 'switch-to-trash-tab',
  SELECTS_MORE_THAN_99_NOTIFICATIONS: 'selects-more-than-99-notifications'
};
export const DELIVERY_METHOD_NAME_MAP = {
  TEASE: 1,
  NOTIFICATION_SIDEBAR: 4,
  BROWSER: 6,
  BANNER: 8,
  FLOATING: 10
};
export const DELIVERY_METHOD_CODE_MAP = {
  1: DELIVERY_METHOD_NAMES.TEASE,
  4: DELIVERY_METHOD_NAMES.SIDEBAR,
  6: DELIVERY_METHOD_NAMES.BROWSER,
  8: DELIVERY_METHOD_NAMES.BANNER,
  10: DELIVERY_METHOD_NAMES.FLOATING
};
export const NOTIFICATION_TYPE_CODE_MAP = {
  4: NOTIFICATION_TYPES.EXPORT,
  5: NOTIFICATION_TYPES.IMPORT,
  6: NOTIFICATION_TYPES.BILLING,
  7: NOTIFICATION_TYPES.ACCOUNT,
  10: NOTIFICATION_TYPES.ASSIGN,
  11: NOTIFICATION_TYPES.COMMENT,
  12: NOTIFICATION_TYPES.MENTION,
  13: NOTIFICATION_TYPES.OVERDUE,
  14: NOTIFICATION_TYPES.REMINDER,
  15: NOTIFICATION_TYPES.ERROR,
  16: NOTIFICATION_TYPES.SHARE,
  18: NOTIFICATION_TYPES.STATUS,
  19: NOTIFICATION_TYPES.COPY,
  20: NOTIFICATION_TYPES.REPLY,
  21: NOTIFICATION_TYPES.REPORTS,
  22: NOTIFICATION_TYPES.LEAD_REVISIT,
  23: NOTIFICATION_TYPES.SUBMISSION,
  24: NOTIFICATION_TYPES.VIEW,
  25: NOTIFICATION_TYPES.FOLLOW,
  26: NOTIFICATION_TYPES.RECOMMENDATION,
  28: NOTIFICATION_TYPES.CUSTOM_AUTOMATION_NOTIFICATION,
  29: NOTIFICATION_TYPES.PARTNER_COLLABORATION,
  10001: NOTIFICATION_TYPES.EXAMPLE,
  10002: NOTIFICATION_TYPES.WELCOME,
  20000: NOTIFICATION_TYPES.GENERAL,
  20002: NOTIFICATION_TYPES.FILE,
  20003: NOTIFICATION_TYPES.PAYMENT
};
export const NOTIFICATION_TYPE_NAME_MAP = Object.fromEntries(Object.entries(NOTIFICATION_TYPE_CODE_MAP).map(([code, type]) => [type, Number(code)]));
export let DISPLAY_STATES;
(function (DISPLAY_STATES) {
  DISPLAY_STATES["OPEN"] = "open";
  DISPLAY_STATES["TRANSITIONING"] = "transitioning";
  DISPLAY_STATES["CLOSED"] = "closed";
})(DISPLAY_STATES || (DISPLAY_STATES = {}));
export const bannerContainerId = 'notificationBannerContainer';
export const DELIVERY_METHOD_PARAM = 'deliveryMethod';
export const hiddenTypes = [NOTIFICATION_TYPES.WELCOME, NOTIFICATION_TYPES.EXAMPLE, NOTIFICATION_TYPES.CONNECT_COM];
export let SIDEBAR_STATE;
(function (SIDEBAR_STATE) {
  SIDEBAR_STATE["NORMAL"] = "NORMAL";
  SIDEBAR_STATE["UNDO"] = "UNDO";
  SIDEBAR_STATE["ALL_ARCHIVED"] = "ALL_ARCHIVED";
  SIDEBAR_STATE["ARCHIVE"] = "ARCHIVE";
  SIDEBAR_STATE["ERROR"] = "ERROR";
})(SIDEBAR_STATE || (SIDEBAR_STATE = {}));
export let PROFILE_TYPES;
(function (PROFILE_TYPES) {
  PROFILE_TYPES["USER"] = "USER";
  PROFILE_TYPES["COMPANY"] = "COMPANY";
  PROFILE_TYPES["CONTACT"] = "CONTACT";
  PROFILE_TYPES["STRING"] = "STRING";
  PROFILE_TYPES["URL"] = "URL";
})(PROFILE_TYPES || (PROFILE_TYPES = {}));
export let TYPE_KEYS;
(function (TYPE_KEYS) {
  TYPE_KEYS["comment"] = "comment";
  TYPE_KEYS["follow"] = "note";
  TYPE_KEYS["mention"] = "mention";
  TYPE_KEYS["reply"] = "reply";
})(TYPE_KEYS || (TYPE_KEYS = {}));
export const SIDEBAR_BATCH_ACTIONS = {
  MARK_AS_READ: 'MARK_AS_READ',
  MARK_AS_UNREAD: 'MARK_AS_UNREAD',
  MARK_AS_DELETED: 'MARK_AS_DELETED',
  MARK_AS_UNDELETED: 'MARK_AS_UNDELETED'
};